import styled from "styled-components"
import {
  FooterWrapperStyles,
  FooterInnerStyles,
  LegalStyles,
  LogoWrapperStyles,
  StyledLinkStyles,
  SocialWrapperStyles,
  SocialIconStyles,
  LinksStyles
} from "./footer-styles"
import { BreakPoints, media } from "../../helpers/rwd"
import { Link } from "gatsby"

export const FooterWrapper = styled.footer`
  background: #000;
  width: 100%;
  padding: 30px 0;
  position: relative;
  ${FooterWrapperStyles}
`

export const FooterInner = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1440px;
  margin: auto;
  padding: 0 20px;
  flex-direction: column;
  ${media.max(BreakPoints.tablet)} {
    flex-direction: column;
    align-items: center;
  }
  ${FooterInnerStyles}
`

export const Left = styled.div`
  max-width: 850px;
`

export const LinksWrapper = styled.div`
  max-width: 850px;
`

export const Logos = styled.div`
  display: flex;
  ${media.max(BreakPoints.phone)} {
    flex-direction: column;
    align-items: center;
  }
  & > a {
    margin: 20px 0;
  }
`

export const Links = styled.div`
  padding-bottom: 5px;
  ${media.max(BreakPoints.phone)} {
    text-align: center;
  }
  ${LinksStyles};
`

export const Legal = styled.div`
  padding: 10px 0;
  ${LegalStyles}
`
export const Social = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  a {
    padding: 8px 0px;
  }
  ${media.max(BreakPoints.tablet)} {
    flex-wrap: wrap;
    margin: 10px 0;
  }
`
interface ISocialLink {
  service: string
  spritesheet: string
}
const socialServiceToShift: any = {
  facebook: "0",
  twitter: "-45px",
  discord: "-90px",
  youtube: "-135px",
  instagram: "-180px",
  reddit: "-225px",
  twitch: "-270px",
  tiktok: "-315px",
  "": "0",
}

export const SocialIcon = styled.div<ISocialLink>`
  opacity: 0.85;
  margin: 0 8px;
  background: transparent url(${props => props.spritesheet}) no-repeat;
  background-position: ${props => socialServiceToShift[props.service]} -30px;
  &:hover {
    opacity: 1;
  }
  ${SocialIconStyles};
`

export const LocalesWrapper = styled.div`
  ${media.max(BreakPoints.tablet)} {
    position: absolute;
    right: 0;
    top: 61px;
}
`

export const StyledLink = styled(Link)`
  padding: 0 10px;
  ${StyledLinkStyles}
`

export const LocalesSocialWrapper = styled.div`
  display: flex;
  position: relative;
`

export const LogoWrapper = styled(Link)`
  padding: 0 20px;
  ${LogoWrapperStyles}
`

export const SocialWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${SocialWrapperStyles}
`
